import { IStyle } from '@fluentui/react';

import { IH2OTheme } from '../../models/components.models';
import { FontSizes, FontWeights, Sizes } from '../../themes/styles';
import { CommonStyles } from '../../themes/themes';

export interface IBasicCardStyles {
  root: IStyle;
  content: IStyle;
  thumbnail: IStyle;
  title: IStyle;
  titleText: IStyle;
  contentBody: IStyle;
  description: IStyle;
  count: IStyle;
  icon: IStyle;
}

export interface IBasicCardClassNames {
  root: string;
  content: string;
  thumbnail: string;
  title: string;
  titleText: string;
  contentBody: string;
  description: string;
  count: string;
  icon: string;
}

export const basicCardStylesDefault = (theme: IH2OTheme): IBasicCardStyles => ({
  root: {
    display: 'flex',
    position: 'relative',
    textAlign: 'inherit', // for button
    padding: Sizes.padding,
    border: `1px solid ${theme.palette?.gray300}`,
    width: '100%',
    borderRadius: Sizes.borderRadius,
    '&.selected': {
      borderColor: theme.palette?.primary500,
      backgroundColor: theme.palette?.primary100,
      '.h2o-BasicCard-title, .h2o-BasicCard-description': {
        color: theme.palette?.primary900,
      },
    },
    '&.clickable': {
      cursor: 'pointer',
    },
    '&.has-icon': {
      paddingRight: '46px',
    },
  },
  thumbnail: {
    width: 40,
    height: 40,
    minWidth: 40,
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundColor: theme.palette?.gray200,
    overflow: 'hidden',
    position: 'relative',
    borderRadius: Sizes.borderRadius,
    marginRight: 8,
  },
  content: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    minWidth: '0px',
  },
  title: {
    width: '100%',
  },
  titleText: {
    fontWeight: FontWeights.semiBold,
    lineHeight: 17,
    ...CommonStyles.truncateString,
  },
  contentBody: { flex: 1, display: 'flex', minHeight: 0, height: '100%' },
  description: {
    flex: 1,
    paddingTop: '8px',
    color: theme.semanticColors?.textSecondary,
    lineHeight: 21,
    overflow: 'auto',
  },
  count: {
    color: theme.semanticColors?.textPrimary,
    fontSize: FontSizes.xlarge,
    fontWeight: FontWeights.semiBold,
    lineHeight: '20px',
  },
  icon: {
    position: 'absolute',
    height: '100%',
    top: 0,
    right: '16px',
    ...CommonStyles.flexCenterVertically,
  },
});

export const basicCardStylesCount = (theme: IH2OTheme): Partial<IBasicCardStyles> => ({
  root: { borderWidth: '0px', backgroundColor: theme.semanticColors?.contentBackground },
  title: {
    fontSize: FontSizes.xxsmall,
    color: theme.semanticColors?.textSecondary,
    lineHeight: '15px',
  },
  description: {
    fontSize: FontSizes.xxxsmall,
    paddingTop: '4px',
    lineHeight: '12px',
    overflow: 'visible',
  },
});
